import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || import.meta.env.MODE,
  release: import.meta.env.VITE_SENTRY_RELEASE || undefined,

  // Enable whenever DSN is set (including local beta with VITE_SENTRY_ENVIRONMENT=local).
  enabled: Boolean(import.meta.env.VITE_SENTRY_DSN),

  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.breadcrumbsIntegration({
      console: false,
      dom: true,
      fetch: true,
      history: true,
    }),
  ],

  tracesSampleRate: 0.2,

  tracePropagationTargets: [
    /^https:\/\/.*\.onrender\.com/,
    /^https:\/\/api\.landsentry\.com/,
    /^https:\/\/.*\.supabase\.co/,
  ],

  ignoreErrors: [
    'ResizeObserver loop limit exceeded',
    'ResizeObserver loop completed with undelivered notifications',
    'Non-Error promise rejection captured',
    /Loading chunk .* failed/,
  ],

  _experiments: {
    enableLogs: true,
  },
});

Sentry.setTag('service', 'frontend');
